import { BlaestProduct } from "@/formatters/types";
import {
  CentraProductItemBasic,
  CentraProductItemFull,
} from "@frend-digital/centra/types";
import "@total-typescript/ts-reset/filter-boolean";

function isServerSize(
  item: CentraProductItemFull | CentraProductItemBasic,
): item is CentraProductItemFull {
  return (item as CentraProductItemFull).warehouses != undefined;
}

export const formatProductSizes = (product: BlaestProduct) => {
  const sizeLabels = product.tableMappings?.Label.x;
  const sizes = product.items?.map(item => {
    const isFull = isServerSize(item);
    try {
      return {
        name: item.name,
        label: sizeLabels?.[item.name] || item.name,
        stock: item.stock !== "no",
        itemId: item.item,
        fewLeft: item.stock === "few",
        warehouses: isFull ? item.warehouses : undefined,
      };
    } catch (_e) {}
  });
  return (sizes || []).filter(Boolean);
};
